import { useContext, useEffect, useRef, useState } from 'react'
import {
  FunctionalDiagramEditContext,
  SELECT_DESELECT_CONNECTOR_CATEGORIS,
} from './context/context'
import CheckBox from '../../../common/CheckBox'

const CategoryFilter = (props) => {
  const categoryFilterWrapperRef = useRef(null)
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)
  const [showCategoryFilter, setShowCategoryFilter] = useState(false)

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideategoryFilter, false)
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutsideategoryFilter,
        false
      )
    }
  }, [])

  const handleClickOutsideategoryFilter = (event) => {
    if (
      categoryFilterWrapperRef.current &&
      !categoryFilterWrapperRef.current.contains(event.target)
    ) {
      setShowCategoryFilter(false)
    }
  }

  return (
    <div ref={categoryFilterWrapperRef}>
      <div
        className={`py-1 px-3 ${state.selectedConnectorCategories?.length > 0 ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex text-base font-medium items-center`}
        onClick={() => {
          setShowCategoryFilter(true)
        }}
      >
        Select Category
        {state.selectedConnectorCategories?.length > 0 && (
          <span className="">&#x25B2;</span>
        )}
      </div>
      {showCategoryFilter && (
        <div style={{ position: 'relative' }}>
          <div
            className={'menu-option-wrapper bg-tracer-darker-blue w-full ml-1'}
            style={{
              position: 'absolute',
              zIndex: 100,
              right: 0,
              width: '15vw',
            }}
          >
            {state?.connectorCategories?.map((category, categoryIndex) => {
              return (
                <div
                  className={`hover:bg-blue-100 flex flex-row items-center bg-white w-full px-4 py-2 border-b border-tracer-dark-blue`}
                  key={`category-${categoryIndex}-${category.value}`}
                >
                  <div>
                    <CheckBox
                      name={'inputName'}
                      value={state.selectedConnectorCategories?.includes(
                        category.value
                      )}
                      onChange={() => {
                        dispatch({
                          type: SELECT_DESELECT_CONNECTOR_CATEGORIS,
                          data: category.value,
                        })
                      }}
                      checked={state.selectedConnectorCategories?.includes(
                        category.value
                      )}
                    />
                  </div>
                  <div className="w-full pl-4">
                    <div className="font-bold">{category.name}</div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default CategoryFilter
